import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { recordContentVisit, type ContentType } from "./contentApi";
import { visitSessionId } from "./visitSession";

export function useContentVisit(
  type: ContentType,
  definitions: readonly { name: string }[]
) {
  const { pathname } = useLocation();
  useEffect(() => {
    const name = matchPath(`/${type}/:name`, pathname)?.params.name;
    if (!name || !definitions.some((item) => item.name === name)) return;
    // The server deduplicates repeated navigation and effect remounts.
    recordContentVisit(type, name, visitSessionId()).catch(() => {});
  }, [pathname, type, definitions]);
}
